import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-tech',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-tech.component.html',
  styleUrl: './offer-tech.component.css',
})
export class OfferTechComponent {
  header = input<string>();
  bold1 = input<string>();
  text1 = input<string>();
  bold2 = input<string>();
  text2 = input<string>();
  bold3 = input<string>();
  text3 = input<string>();
  bold4 = input<string>();
  text4 = input<string>();
}
